import PropTypes from 'prop-types'
import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { fullDayDateAndTimeWithTimezone } from '@utils/dateUtils'

const SessionsAccordion = ({
  sessions,
  timezone,
  isExpanded,
  setIsExpanded,
}) => {
  return (
    <>
      <Typography
        variant="body1"
        color="primary"
        style={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {sessions.length} sessions
      </Typography>
      <Box pt={1} pl={2} display={isExpanded ? 'block' : 'none'}>
        {sessions.map(s => (
          <Box pb={1} key={s.startDateTime}>
            <Typography variant="body1">{fullDayDateAndTimeWithTimezone(s.startDateTime, s.endDateTime, timezone)}</Typography>
          </Box>
        ))}
      </Box>
    </>
  )
}

SessionsAccordion.propTypes = {
  sessions: PropTypes.arrayOf(PropTypes.shape({
    startDateTime: PropTypes.string,
    endDateTime: PropTypes.string,
  })),
  timezone: PropTypes.string,
  isExpanded: PropTypes.bool,
  setIsExpanded: PropTypes.func,
}

export default SessionsAccordion
